<template lang="pug">
    .main
      el-scrollbar(class="aside-scrollbar")
        el-menu(
          :default-active="$route.path"
          :collapse="isCollapse"
          mode="vertical"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF")
          el-menu-item.avatar
            el-avatar.report-avatar(:src="circleUrl")
          sidebar-item(v-for="(item, index) in routes"
                      :key="item.path"
                      :item="item"
                      :base-path="item.path")
</template>
<script>
import SidebarItem from './Sidebar/SidebarItem'
import passport from '@/javascripts/passport'
import { hasPermission } from '@/javascripts/auth'

export default {
  components: { SidebarItem },
  created () {
    // console.log(this.$router.options.routes)
    if (localStorage.passport) {
      const token = localStorage.passport
      this.circleUrl = this.$jwt.decode(token) && this.$jwt.decode(token).avatar
    }
  },
  data () {
    return {
      isCollapse: false,
      onlyOneChild: null,
      circleUrl: ''
    }
  },
  computed: {
    routes () {
      const routes = JSON.parse(JSON.stringify(this.$router.options.routes))
      this.filterRouterByRole(routes)
      return routes
    }
  },
  methods: {
    // route roles里与则判断，身份权限是否在内。在内则显示，不在内则隐藏，设置hidden: true
    filterRouterByRole (routes) {
      routes.forEach(route => {
        if (route.children && route.children.length > 0) {
          this.filterRouterByRole(route.children)
          // 如果子路由都是隐藏的则隐藏。
          route.hidden = route.children.every(child => {
            return child.hidden === true
          })
        }
        if (route.meta && route.meta.roles && route.meta.roles.length > 0) {
          const hasAuth = hasPermission(passport.getUserInfo() && passport.getUserInfo().roles, route.meta.roles)
          if (!hasAuth) {
          // if (!route.meta.roles.includes(passport.getUserInfo() && passport.getUserInfo().roles)) {
            route.hidden = true
          } else {
            route.hidden = false
          }
        }
      })
    },

    hasOneShowingChild (children, parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss">
.el-menu {
  .el-menu-item.avatar {
    background-color: #304156 !important;
    cursor: default;
  }

  .report-avatar {
    cursor: pointer;
  }
  .avatar{
    text-align: center;
  }
}

.el-scrollbar{
  height: 100%;
  overflow: hidden;
}
.el-scrollbar__view{
  height: 100%;
}
.aside-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden !important;
}
</style>
